import { graphql } from "../../services/wp.api.service";

const query = `
mutation ValidatePromoCode($code: String!) {
  validatePromoCode(input: {code: $code}) {
    promo_code {
      amount_off
      code
      currency
      duration
      id
      percent_off
      redeem_by
      times_redeemed
    }
  }
}`

const getPromoCodeMutation = (useMutation) => useMutation(
	["getPromoCode"],
	({ code }) => graphql({
		query,
		variables: {
			code
		}
	})
);

export default getPromoCodeMutation;